import { useSelector } from 'react-redux';
// @ts-expect-error not typed
import { calculateUnseenThreadsCount } from '../../threads/selectors/calculateUnseenThreadsCount';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getIsOpen } from '../../selectors/getIsOpen';
// @ts-expect-error not typed
import { getShowLauncherBadge } from '../../visitor-widget/selectors/getShowLauncherBadge';
import { getAvatar, getIsResponderAI } from 'conversations-internal-schema/responders/operators/responderGetters';
// @ts-expect-error not typed
import { getAnyCompanyLogo } from 'conversations-internal-schema/chat-heading-config/operators/getAnyCompanyLogo';
import { getChatHeadingConfig } from '../../chat-heading-config/selectors/getChatHeadingConfig';
import { getWidgetSize } from '../../widget-size/widgetSizeSelectors';
import { useContext } from 'react';
import { BrowserWindowContext } from '../../components/BrowserWindowContext';
import { getSendFrom } from '../../widget-data/selectors/getSendFrom';
import LauncherContainer from 'conversations-visitor-experience-components/visitor-widget/LauncherContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const {
    browserWindowWidth
  } = useContext(BrowserWindowContext);
  const badgeNumber = useSelector(calculateUnseenThreadsCount);
  const coloring = useSelector(getColoring);
  const open = useSelector(getIsOpen);
  const showBadge = useSelector(getShowLauncherBadge);
  const sendFromResponders = useSelector(getSendFrom);
  const chatHeadingConfig = useSelector(getChatHeadingConfig);
  const companyLogo = getAnyCompanyLogo(chatHeadingConfig);
  const widgetSize = useSelector(getWidgetSize);
  const responderAvatarImageSrcs = sendFromResponders.toArray().map(responder => getAvatar(responder));
  const avatarImageSrcs = responderAvatarImageSrcs.length > 0 ? responderAvatarImageSrcs : [companyLogo];
  const isResponderAI = sendFromResponders.some(responder => Boolean(getIsResponderAI(responder)));
  return {
    badgeNumber,
    coloring,
    open,
    showBadge,
    isResponderAI,
    avatarImageSrcs,
    widgetSize,
    browserWindowWidth
  };
};
const LauncherContainerWrapper = props => {
  const componentProps = useComponent();
  return /*#__PURE__*/_jsx(LauncherContainer, Object.assign({}, props, componentProps));
};
LauncherContainerWrapper.displayName = 'LauncherContainerWrapper';
export default LauncherContainerWrapper;